import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Option } from '@digilize/shared/definitions/src';
import { TranslateService } from '@ngx-translate/core';
import { Company } from '../../models/company.model';
import { CompanyMockService } from '../../services/company-mock.service';

@Component({
  selector: 'bwc-discover-companies',
  templateUrl: './discover-companies.component.html',
  styleUrls: ['./discover-companies.component.scss'],
})
export class DiscoverCompaniesComponent implements OnInit {
  companies: Company[] = [];
  visibleCount = 30;
  followedIds: number[] = [];
  searchTerm = '';
  hasSearched = false;

  fieldsControl = new FormControl('');
  sectorsControl = new FormControl('');
  languagesControl = new FormControl('');
  sizesControl = new FormControl('');

  fieldsOptions: Option[] = [];
  sectorsOptions: Option[] = [];
  languagesOptions: Option[] = [];
  sizesOptions: Option[] = [];

  constructor(
    private companyService: CompanyMockService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.companyService.getCompanies().subscribe(c => (this.companies = c));
    this.followedIds = this.companyService.getFollowedIds();

    this.fieldsOptions = [
      { text: this.translateService.instant('shared.all_fields'), val: '' },
    ];
    this.sectorsOptions = [
      { text: this.translateService.instant('companies.discover.filter_all_sectors'), val: '' },
    ];
    this.languagesOptions = [
      { text: this.translateService.instant('companies.discover.filter_all_languages'), val: '' },
    ];
    this.sizesOptions = [
      { text: this.translateService.instant('companies.discover.filter_all_sizes'), val: '' },
    ];
  }

  get visibleCompanies(): Company[] {
    return this.companies.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.companies.length;
  }

  search(): void {
    this.hasSearched = true;
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + 30, this.companies.length);
  }

  isFollowed(id: number): boolean {
    return this.followedIds.includes(id);
  }

  toggleFollow(company: Company): void {
    const followed = this.companyService.toggleFollowCompany(company);
    this.followedIds = followed
      ? [...this.followedIds, company.id]
      : this.followedIds.filter(id => id !== company.id);
  }

  onFieldsSelected(_event: Option): void {}

  onSectorsSelected(_event: Option): void {}

  onLanguagesSelected(_event: Option): void {}

  onSizesSelected(_event: Option): void {}
}
